var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9321 0.5H3.06792C1.65193 0.5 0.5 1.74683 0.5 3.27938V12.6765C0.5 14.2091 1.65193 15.4559 3.06792 15.4559H4.0756L4.09532 17.9096C4.09708 18.1357 4.21707 18.3412 4.40502 18.4401C4.48137 18.4803 4.56364 18.5 4.64548 18.5C4.76498 18.5 4.8836 18.4579 4.98175 18.3759L8.47713 15.456H15.9321C17.348 15.456 18.5 14.2091 18.5 12.6766V3.27938C18.5 1.74683 17.348 0.5 15.9321 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.0e6667e7129befc9800fc85a641816d4.svg";
export { ForwardRef as ReactComponent };